import React, {
	useState,
	useRef,
	useCallback,
	useEffect,
	useMemo,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import ReactFlow, {
	ReactFlowProvider,
	addEdge,
	SmoothStepEdge,
	useNodesState,
	useEdgesState,
	Controls,
	Background,
	BackgroundVariant,
	MarkerType,
} from "reactflow";
import "reactflow/dist/style.css";
import Sidebar from "./Sidebar";
import "./Flow.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import plus1 from "../../assets/icons/plus1.svg";

import "../../assets/css/templateBuilder.css";
import "../../assets/css/addunit.css";
import "../../assets/css/mainMenu.css";

import search1 from "../../assets/icons/search1.svg";
import close from "../../assets/icons/close.svg";
import folder from "../../assets/icons/folder.svg";
import ImageNode from "./ImageNode";
import DefaultNode from "./DefaultNode";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import Select, { components } from "react-select";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";

const DnDFlow = () => {
	const [showTable, setShowTable] = useState(false);
	const [loading, setLoading] = useState(false);
	const [masterId, setMasterId] = useState("");
	const [data1, setData1] = useState([]);
	const [allChecked, setAllChecked] = useState(false);

	const [checkedItems, setCheckedItems] = useState([]);
	const [checkedItems1, setCheckedItems1] = useState([]);
	const [previousConnections, setPreviousConnections] = useState([]);
	const [selectedConnections, setSelectedConnections] = useState({});
	const reactFlowWrapper = useRef(null);
	const [master, setMaster] = useState([]);
	const [nodes, setNodes, onNodesChange] = useNodesState([]);
	const [edges, setEdges, onEdgesChange] = useEdgesState([]);
	const [reactFlowInstance, setReactFlowInstance] = useState(null);
	const [selectedNode, setSelectedNode] = useState(null);

	const [contextMenu, setContextMenu] = useState({
		isOpen: false,
		position: { x: 0, y: 0 },
	});
	const [usedNodes, setUsedNodes] = useState([]);
	const [edgeToDelete, setEdgeToDelete] = useState(null);
	const [edgeLabelModal, setEdgeLabelModal] = useState({
		isOpen: false,
		label: "",
		edgeId: null,
	}); // New state for edge label modal
	const templateNameRef = useRef(null);
	const [templateName, setTemplateName] = useState("");
	const [templateNameInput, setTemplateNameInput] = useState("");
	const [templateCode, setTemplateCode] = useState("");
	const [templateId, setTemplateId] = useState("");
	const [isMenuVisible, setIsMenuVisible] = useState(false);
	const { template_type_id, template_id } = useParams();
	const [TemplateTypeName, setTemplateTypeName] = useState("");
	const [shouldFetch, setShouldFetch] = useState(false);

	const [searchQuery, setSearchQuery] = useState("");
	const [searchTerm1, setSearchTerm1] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(50);
	const [allSelected, setAllSelected] = useState({});
	const [allSelectedItems, setAllSelectedItems] = useState({});
	const navigate = useNavigate();
	const dropdownRef = useRef(null);


	const [nodeArray, setNodeArray] = useState([]);
	const [edgeArray, setEdgeArray] = useState([]);
	const [sourceId, setSourceId] = useState("");
	const [sourceName, setSourceName] = useState("");

	const [leafNode, setLeafNode] = useState(false);


	const [isOpen, setIsOpen] = useState(false);
	const [selectedItems, setSelectedItems] = useState([]);

	const searchInputRef = useRef(null);

	const [connectedNodeNames, setConnectedNodeNames] = useState([]);
	// const toggleNewDropdown = () => {
	//   setNewDropdownOpen(!newDropdownOpen);
	// };

	const handleClickOutside = (event) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	// Debounce search to improve performance
	const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
	const [debouncedSearchTerm1, setDebouncedSearchTerm1] = useState("");

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedSearchQuery(searchQuery);
		}, 300);
		return () => clearTimeout(timer);
	}, [searchQuery]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedSearchTerm1(searchTerm1);
		}, 300);
		return () => clearTimeout(timer);
	}, [searchTerm1]);

	const handleSearchChange = (e) => {
		setSearchQuery(e.target.value);
		setCurrentPage(1); // Reset to first page on search
		if (!showTable) {
			setShowTable(true); // Show table when search input changes
		}
	};

	const toggleDropdown = () => {
		setIsOpen(!isOpen);
		if (!isOpen) {
			setTimeout(() => {
				searchInputRef.current.focus();
			}, 0);
		}
	};

	const nodeTypes = useMemo(
		() => ({
			imageNode: ImageNode,
			defaultNode: DefaultNode,
		}),
		[]
	);

	const edgeTypes = useMemo(
		() => ({
			smoothstep: SmoothStepEdge,
		}),
		[]
	);

	const ADDFun = () => {
		if (checkedItems1.length === 0 || selectedItems.length === 0) {
			toast.error("Please select at least one item from each dropdown");
			return;
		}

		// Merge new connections with existing selectedConnections to preserve previous selections
		setSelectedConnections((prevSelectedConnections) => {
			// Ensure prevSelectedConnections is an object
			const prevConnections = prevSelectedConnections && typeof prevSelectedConnections === 'object' && !Array.isArray(prevSelectedConnections)
				? prevSelectedConnections
				: {};

			const updatedConnections = { ...prevConnections };

			checkedItems1.forEach((checkedItem) => {
				// Overwrite the dropdown selections for the checked item
				updatedConnections[checkedItem] = selectedItems.map((item) => ({ ...item }));
			});

			// Update checkedItems to include all items that have connections (both new and existing)
			const allItemsWithConnections = Object.keys(updatedConnections).filter(
				(itemId) => updatedConnections[itemId] && updatedConnections[itemId].length > 0
			);

			// Update checkedItems and allChecked
			setCheckedItems(allItemsWithConnections);
			if (data1?.data) {
				setAllChecked(
					data1.data.every((item) =>
						item.status ? allItemsWithConnections.includes(item._id) : true
					)
				);
			}

			return updatedConnections;
		});

		// Reset dropdown states
		setCheckedItems1([]);
		setSelectedItems([]);
		setSearchQuery("");
		setAllSelectedItems({});
	};

	const fetchNodes = async () => {
		setLoading(true);
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-type-master/${template_type_id}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
				},
				navigate // Include navigate for error handling
			);


			setMaster(data);

			setTemplateTypeName(data.templateType.template_type_name);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching nodes:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login"); // Navigate to login if unauthorized
			}
		}
	};

	const onConnect = useCallback(
		(params) => {
			const { source, sourceHandle, target, targetHandle } = params;

			// Check if either source or target handle is already connected
			const isSourceHandleConnected = edges.some(
				(edge) => edge.source === source && edge.sourceHandle === sourceHandle
			);
			const isTargetHandleConnected = edges.some(
				(edge) => edge.target === target && edge.targetHandle === targetHandle
			);

			// Determine the first node based on the drag-and-drop order rather than position
			const firstNodeId = nodes.length > 0 ? nodes[0].id : null;

			if (target === firstNodeId) {
				toast.error("The first node cannot have input connections.");
				return;
			}

			if (isSourceHandleConnected || isTargetHandleConnected) {
				// Show error if either handle already has a connection
				toast.error("Only one connection is allowed per handle");
				return; // Do not add the edge
			}

			// Add the edge
			setEdges((eds) =>
				addEdge(
					{
						...params,
						type: "smoothstep",
						markerEnd: { type: MarkerType.ArrowClosed },
						label: "",
					},
					eds
				)
			);

			// Update the sequence of connected nodes
			const sourceNode = nodes.find((node) => node.id === source);
			const targetNode = nodes.find((node) => node.id === target);

			setConnectedNodeNames((prev) => {
				// Ensure nodes are added in the correct order without duplication
				const updatedNames = prev.includes(sourceNode.data.label)
					? [...prev, targetNode.data.label]
					: [...prev, sourceNode.data.label, targetNode.data.label];
				return updatedNames;
			});
		},
		[edges, nodes, setEdges]
	);

	const onDragOver = useCallback((event) => {
		event.preventDefault();
		event.dataTransfer.dropEffect = "move";
	}, []);

	const onDrop = useCallback(
		(event) => {
			event.preventDefault();

			if (!reactFlowWrapper.current) {
				return;
			}

			const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
			const masterId = event.dataTransfer.getData("application/reactflow");

			if (
				typeof masterId === "undefined" ||
				!masterId ||
				!reactFlowInstance ||
				!master.parameter_types.length
			) {
				return;
			}

			const position = reactFlowInstance.project({
				x: event.clientX - reactFlowBounds.left,
				y: event.clientY - reactFlowBounds.top,
			});

			const masterDataItem = master.parameter_types
				.flatMap((parameterType) => parameterType.masters)
				.find((m) => m._id === masterId);

			if (!masterDataItem) {
				console.warn(`Master item not found for ID: ${masterId}`);
				return;
			}

			const newNode = {
				id: `${masterId}`,
				type: "defaultNode",
				position,
				sourcePosition: "right",
				targetPosition: "left",
				data: {
					label: masterDataItem.master_name,
					img: masterDataItem.img,
				},
			};

			setNodes((nds) => nds.concat(newNode));
			setUsedNodes((prev) => [...prev, masterId]);
		},
		[reactFlowInstance, master, nodes, usedNodes]
	);

	const closeModal = () => {
		setSelectedNode(null);
		setAllChecked(false);
		setIsMenuVisible(false);
	};

	const openEdgeLabelModal = (edgeId) => {
		const edge = edges.find((e) => e.id === edgeId);
		const currentLabel = edge?.label || "";
		setEdgeLabelModal({ isOpen: true, label: currentLabel, edgeId });
	};

	const addLabelToEdge = (edgeId, label) => {
		setEdges((eds) =>
			eds.map((edge) => (edge.id === edgeId ? { ...edge, label } : edge))
		);
		setEdgeLabelModal({ isOpen: false, label: "", edgeId: null });
	};

	const onEdgeClick = (event, edge) => {
		event.stopPropagation();

		closeContextMenu();
		if (!reactFlowWrapper.current) {
			return;
		}

		const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
		const xPosition = event.clientX - reactFlowBounds.left;
		const yPosition = event.clientY - reactFlowBounds.top;
		setEdgeToDelete({ id: edge.id, position: { x: xPosition, y: yPosition } });
	};

	const onDeleteEdge = () => {
		if (edgeToDelete) {
			setEdges((eds) => eds.filter((edge) => edge.id !== edgeToDelete.id));
			setEdgeToDelete(null);
		}
	};

	const onNodeDoubleClick = async (event, node) => {
		event.preventDefault();
		if (edgeToDelete) {
			setEdgeToDelete(null);
		}

		setSelectedNode(node);
		setMasterId(node.id);

		getSourceId(edgeArray, node.id);
		getTargetId(edgeArray, node.id);

		setCheckedItems([]);
		setShouldFetch(true);


		// fetchData();
		// fetchMasterData(node.id);
		setIsMenuVisible(true);
	};

	const onNodeContextMenu = async (event, node) => {
		event.preventDefault();
		if (edgeToDelete) {
			setEdgeToDelete(null);
		}
		if (!reactFlowWrapper.current) {
			return;
		}
		const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
		const xOffset = 100;
		setContextMenu({
			isOpen: true,
			position: {
				x: event.clientX - xOffset,
				y: event.clientY - reactFlowBounds.top,
			},
		});
		setSelectedNode(node);
		// setMasterId(node.id);
		getSourceId(edgeArray, node.id);


		// await fetchMasterData(node.id);

		if (node.id !== "firstNodeIdentifier") {
		}
	};
	// const filteredData =
	//   data1 && data1.data
	//     ? data1.data.filter((item) => {
	//       return (
	//         item._id.toString().includes(searchQuery) ||
	//         data1.master.masterFields.some((field) => {
	//           return (item[field.field_name] || "")
	//             .toString()
	//             .toLowerCase()
	//             .includes(searchQuery.toLowerCase());
	//         })
	//       );
	//     })
	//     : [];

	// const [searchQuery, setSearchQuery] = useState("");

	// Memoize filtered data to avoid recalculating on every render
	const filteredData = useMemo(() => {
		if (!data1?.data) return [];

		const filtered = previousConnections.length === 0
			? data1.data.filter((item) =>
				Object.values(item).some(
					(value) =>
						typeof value === "string" &&
						value.toLowerCase().includes(debouncedSearchTerm1.toLowerCase())
				)
			)
			: data1.data.filter((item) =>
				item._id.toString().includes(debouncedSearchQuery) ||
				data1.master?.masterFields?.some((field) =>
					(item[field.field_name] || "")
						.toString()
						.toLowerCase()
						.includes(debouncedSearchQuery.toLowerCase())
				)
			);

		return filtered;
	}, [data1?.data, previousConnections.length, debouncedSearchTerm1, debouncedSearchQuery, data1?.master?.masterFields]);

	// Paginate the filtered data
	const paginatedData = useMemo(() => {
		const startIndex = (currentPage - 1) * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;
		return filteredData.slice(startIndex, endIndex);
	}, [filteredData, currentPage, itemsPerPage]);

	// Calculate total pages
	const totalPages = useMemo(() => {
		return Math.ceil(filteredData.length / itemsPerPage);
	}, [filteredData.length, itemsPerPage]);

	const startItem = filteredData.length === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
	const endItem = filteredData.length === 0 ? 0 : Math.min(currentPage * itemsPerPage, filteredData.length);
	useEffect(() => {
		if (shouldFetch && sourceId && masterId) {
			setLoading(true);
			fetchAllData()
				.then(() => {
					setLoading(false);
				})
				.catch((error) => {
					console.error("Error fetching data:", error);
					setLoading(false); // Set loading false even on error to stop loading spinner
				});
			setShouldFetch(false);
		}
	}, [shouldFetch, sourceId, masterId]);

	// Handle initial node and edge setup
	useEffect(() => {
		const updateConnectedNodeNames = () => {
			const connectedNodes = [];

			edges.forEach((edge) => {
				const sourceNode = nodes.find((node) => node.id === edge.source);
				const targetNode = nodes.find((node) => node.id === edge.target);

				if (sourceNode && targetNode) {
					connectedNodes.push(sourceNode.data.label);
					connectedNodes.push(targetNode.data.label);
				}
			});

			setConnectedNodeNames([...new Set(connectedNodes)]); // Avoid duplicates
		};

		updateConnectedNodeNames();
	}, [nodes, edges]);

	const fetchAllData = async () => {
		try {
			await Promise.all([
				fetchPreviousConnections(sourceId),
				fetchData(),
				fetchMasterDataCheckbox(masterId),
				fetchMasterData(masterId),
			]);
		} catch (error) {
			throw new Error("Error fetching all data: " + error.message);
		}
	};

	const fetchPreviousConnections = async () => {
		setLoading(true);
		const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-master/${templateId}/${sourceId}`;

		console.log("🔄 Loading template-master data from:", url);
		try {
			const data = await fetchWrapper(
				url,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate // Include navigate for error handling
			);

			// Extract the template_master_codes from the response data
			const previousConnections = data.data.map((item) => ({
				id: item._id,
				template_master_code: item.document_code, // Ensure this is correct
				master_name: item.master_name,
				document_id: item.document_id,
				node: item.node || {}, // Handle cases where node might be undefined
			}));

			setPreviousConnections(previousConnections);

			setLoading(false);
			updateAllSelectedStatus();
		} catch (error) {
			setPreviousConnections([]);
			setLoading(false); // Set loading false even on error to stop loading spinner
			console.error("Error fetching previous connections:", error.message);
			if (error.message === "Unauthorized") {
				navigate("/auth/login"); // Navigate to login if unauthorized
			}
		}
	};

	const fetchData = async () => {
		setLoading(true);

		try {
			const optionsRequestBody = JSON.stringify({ templateId, sourceId });

			const optionsData = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-master/${templateId}/${sourceId}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: optionsRequestBody,
				},
				navigate // Include navigate for error handling
			);

			const optionList = optionsData.data.map((item) => ({
				value: item._id,
				label: item.document_code,
				heading: item.document_heading_code,
			}));

			const selectedRequestBody = JSON.stringify({ templateId, masterId });

			const selectedData = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-master/${templateId}/${masterId}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: selectedRequestBody,
				},
				navigate // Include navigate for error handling
			);

			const initialSelectedConnections = selectedData.data.reduce(
				(acc, item) => {
					const connections = optionList
						.filter((opt) => opt.value === item.node.document_id)
						.map((opt) => ({
							value: opt.value,
							label: opt.label,
							heading: opt.heading,
						}));
					if (connections.length > 0) {
						if (!acc[item.document_id]) {
							acc[item.document_id] = [];
						}
						acc[item.document_id].push(...connections);
					}
					return acc;
				},
				{}
			);

			setSelectedConnections(initialSelectedConnections);
			updateAllSelectedStatus();
			setLoading(false);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			setLoading(false); // Set loading false even on error to stop loading spinner
			if (error.message === "Unauthorized") {
				navigate("/auth/login"); // Navigate to login if unauthorized
			}
		}
	};

	const updateAllSelectedStatus = () => {
		const allSelectedStatus = {};
		Object.keys(selectedConnections).forEach((id) => {
			const selectedLength = selectedConnections[id].length;

			const totalConnectionsLength = previousConnections.length;

			allSelectedStatus[id] = selectedLength === totalConnectionsLength;
		});
		setAllSelected(allSelectedStatus);
	};

	useEffect(() => {

		updateAllSelectedStatus();
	}, [selectedConnections, previousConnections]);

	const fetchMasterDataCheckbox = async () => {
		setLoading(true);
		try {
			// Log the URL for the first API request
			const firstApiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-master/${templateId}/${masterId}`;


			// Fetch previously added items
			const previousDataJson = await fetchWrapper(
				firstApiUrl,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate // Include navigate for error handling
			);


			const { data: previousData } = previousDataJson;
			const previouslyAddedIds = previousData.map((item) => item.document_id);

			// Log the URL for the second API request
			const secondApiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/collections/${masterId}/data`;


			// Fetch the master data which will be displayed in the table
			const masterDataJson = await fetchWrapper(
				secondApiUrl,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate // Include navigate for error handling
			);

			const masterData = masterDataJson.data;

			// Filter out the IDs that match the previously added ones
			const checkedIds = masterData
				.filter((item) => previouslyAddedIds.includes(item._id))
				.map((item) => item._id);

			// Update the state to mark these items as checked
			setCheckedItems(checkedIds);


			if (data1?.data?.length != null) {

				setAllChecked(checkedIds.length === data1.data.length);
			}
			setLoading(false);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login"); // Navigate to login if unauthorized
			}
		}
	};

	const fetchMasterData = async (masterID) => {
		setLoading(true);
		try {
			const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/collections/${masterID}/data`;
			console.log("🔄 Loading collections data from:", url);

			const responseData = await fetchWrapper(
				url,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate // Include navigate for error handling
			);
			console.log('Fetched master data:', responseData);
			setData1(responseData);

			setLoading(false);
			// Ensure responseData has both data and master fields
			const masterFields = responseData.master?.masterFields || [];

			return {
				data: responseData.data || [],
				masterFields: masterFields,
			};
		} catch (error) {
			console.error("Error fetching master data:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login"); // Navigate to login if unauthorized
			}
			return null;
		}
	};

	useEffect(() => {
		if (filteredData.length > 0) {
			// Check if all filtered items with status are checked
			const allFilteredChecked = filteredData
				.filter((item) => item.status)
				.every((item) => checkedItems.includes(item._id));
			setAllChecked(allFilteredChecked);
		} else {
			setAllChecked(false);
		}
	}, [filteredData, checkedItems]);

	// Reset to first page when data changes
	useEffect(() => {
		setCurrentPage(1);
	}, [data1?.data]);

	const renderPaginationControls = () => (
		<div
			className="d-flex flex-wrap align-items-center justify-content-end gap-3 w-100"
			style={{ minWidth: "300px" }}
		>
			<div className="d-flex align-items-center gap-2 flex-shrink-0">
				<label className="text-muted mb-0 small">Rows</label>
				<select
					className="form-select form-select-sm"
					style={{ width: "85px" }}
					value={itemsPerPage}
					onChange={(e) => {
						setItemsPerPage(Number(e.target.value));
						setCurrentPage(1);
					}}
				>
					<option value={25}>25</option>
					<option value={50}>50</option>
					<option value={100}>100</option>
					<option value={200}>200</option>
				</select>
			</div>
			<div className="d-flex align-items-center gap-2 flex-shrink-0" style={{ whiteSpace: "nowrap" }}>
				<button
					className="btn btn-sm btn-outline-secondary"
					onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
					disabled={currentPage === 1 || totalPages === 0}
				>
					Previous
				</button>
				<span className="text-muted small">
					Page {totalPages === 0 ? 0 : currentPage} / {Math.max(totalPages, 1)}
				</span>
				<button
					className="btn btn-sm btn-outline-secondary"
					onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
					disabled={currentPage === totalPages || totalPages === 0}
				>
					Next
				</button>
			</div>
		</div>
	);

	const renderSearchAndPagination = (useSearchTerm1) => (
		<div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3 p-3 pt-0 pb-0">
			<div
				className="d-flex align-items-center gap-3 flex-grow-1"
				style={{
					minWidth: "340px",
					whiteSpace: "nowrap",
				}}
			>
				<div className="flex-grow-1" style={{ minWidth: "240px" }}>
					<input
						type="text"
						className="form-control"
						placeholder="Search..."
						value={useSearchTerm1 ? searchTerm1 : searchQuery}
						onChange={(e) => {
							if (useSearchTerm1) {
								setSearchTerm1(e.target.value);
							} else {
								setSearchQuery(e.target.value);
							}
							setCurrentPage(1);
						}}
					/>
				</div>
				<span className="text-muted small flex-shrink-0" style={{ whiteSpace: "nowrap" }}>
					{filteredData.length === 0
						? "No records"
						: `Showing ${startItem}-${endItem} of ${filteredData.length}`}
				</span>
			</div>
			<div
				className="d-flex justify-content-end flex-grow-1"
				style={{ minWidth: "320px" }}
			>
				{renderPaginationControls()}
			</div>
		</div>
	);
	// useEffect(() => {
	//   const firstNodeId = nodes.length > 0 ? nodes[0].id : null;

	//   if (firstNodeId) {
	//     setNodes((nds) =>
	//       nds.map((node) =>
	//         node.id === firstNodeId
	//           ? {
	//               ...node,
	//               className: "first-node-highlight", // Apply custom class
	//             }
	//           : node
	//       )
	//     );
	//   }
	// }, [nodes, setNodes]);
	const firstNodeId = nodes.length > 0 ? nodes[0].id : null;

	// Function to apply the highlight to the first node
	const highlightFirstNode = useCallback(() => {
		if (firstNodeId) {
			setNodes((nds) =>
				nds.map((node) =>
					node.id === firstNodeId
						? {
							...node,
							className: "first-node-highlight", // Apply custom class
						}
						: node
				)
			);
		}
	}, [firstNodeId, setNodes]);

	useEffect(() => {
		// Only runs once when component mounts
		highlightFirstNode();
	}, [highlightFirstNode]);

	useEffect(() => {
		fetchMasterData();
	}, [setMasterId]);

	const closeContextMenu = () =>
		setContextMenu({ isOpen: false, position: { x: 0, y: 0 } });
	const onDeleteNode = async (nodeToDelete) => {
		setLoading(true);
		try {
			// Make API call to delete the node using URL parameters
			await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template/deleteNode/${templateId}/${nodeToDelete.id}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					// No body needed since parameters are in the URL
				},
				navigate
			);

			// // Remove the node from state
			setNodes((nds) => nds.filter((node) => node.id !== nodeToDelete.id));

			// // Remove associated edges
			setEdges((eds) =>
				eds.filter(
					(edge) =>
						edge.source !== nodeToDelete.id && edge.target !== nodeToDelete.id
				)
			);

			// // Update usedNodes state
			setUsedNodes((used) => used.filter((nodeId) => nodeId !== nodeToDelete.id));

			// // Close context menu
			closeContextMenu();

			// Show success notification
			toast.success("Node deleted successfully");
			setLoading(false);
		} catch (error) {
			// Show error notification
			setLoading(false);
			toast.error(error.message);
		}
	};

	const hideButton = () => {
		if (edgeToDelete) {
			setEdgeToDelete(null);
		}
		closeContextMenu();
	};

	const handleSave = async () => {
		console.log(">>>>>>>>>>>>>>>")
		setLoading(true);
		try {
			const nodesArray = [];
			const edgesArray = [];

			nodes.forEach((node) => {
				const nodeObject = {
					id: node.id,
					type: node.type,
					style: { ...node.style },
					data: {
						...node.data,
					},
					position: {
						x: node.position.x.toFixed(2),
						y: node.position.y.toFixed(2),
					},
					sourcePosition: node.sourcePosition,
					targetPosition: node.targetPosition,
				};
				nodesArray.push(nodeObject);
			});

			edges.forEach((edge) => {
				edgesArray.push({
					id: `${edge.source}->${edge.target}`,
					source: edge.source,
					target: edge.target,
					label: edge.label,
					type: edge.type,
					markerEnd: { ...edge.markerEnd },
				});
			});

			const elements = [{ nodes: nodesArray }, { edges: edgesArray }];
			const elementsJSON = JSON.stringify(elements, null, 2);


			await new Promise((resolve) => setTimeout(resolve, 0));

			const trimmedTemplateName = templateNameInput.trim();
			const trimmedTemplateCode = templateCode.trim();

			// if (trimmedTemplateName === "") {
			//   setLoading(false);
			//   toast.error("Please enter a template name.");
			//   return;
			// }

			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template/update/${templateId}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						template_type_id: `${template_type_id}`,
						template_name: trimmedTemplateName,
						template_code: trimmedTemplateCode,
						structure: elementsJSON,
					}),
				},
				navigate // Include navigate for error handling
			);

			setLoading(false);
			navigate(`/template_types/${template_type_id}`);
			setTimeout(() => {
				toast.success("Template updated successfully");
			}, 200);
		} catch (error) {
			setLoading(false);
			toast.error(error.message);
			if (error.message === "Cannot update structure as the template is already used in an asset") {
				// window.location.reload();

			}
		}
	};

	useEffect(() => {
		fetchNodes();
	}, []);

	useEffect(() => {
		if (reactFlowInstance) {

		}
	}, [reactFlowInstance]);

	useEffect(() => {
		const fetchTemplateData = async () => {
			setLoading(true);
			try {
				const data = await fetchWrapper(
					`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template/${template_id}`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
					},
					navigate
				);



				setTemplateName(data.template_name);
				setTemplateNameInput(data.template_name);
				setTemplateCode(data.template_code);
				setTemplateId(data._id);

				let structure;
				try {
					structure = JSON.parse(data.structure);
				} catch (error) {
					console.error("Error parsing structure JSON:", error);
					return;
				}



				const nodesArray = structure.find((item) => item.nodes)?.nodes;
				const edgesArray = structure.find((item) => item.edges)?.edges;


				setNodeArray(nodesArray);


				setEdgeArray(edgesArray);

				if (!Array.isArray(nodesArray)) {
					console.error(
						"Nodes array is missing or is not an array:",
						nodesArray
					);
					return;
				}

				if (!Array.isArray(edgesArray)) {
					console.error(
						"Edges array is missing or is not an array:",
						edgesArray
					);
					return;
				}

				const iNodes = [];
				const iEdges = [];

				nodesArray.forEach((node) => {
					iNodes.push({
						id: node.id,
						type: node.type || "defaultNode",
						position: {
							x: parseFloat(node.position.x),
							y: parseFloat(node.position.y),
						},
						data: { label: node.data.label },
						sourcePosition: node.sourcePosition,
						targetPosition: node.targetPosition,
						style: { ...node.style } || { height: 20, width: 100 },
					});
					setUsedNodes((prev) => [...prev, node.id]);
				});

				edgesArray.forEach((edge) => {
					const edgeId = edge.id.replace("->", "-");

					iEdges.push({
						id: `reactflow__edge-${edgeId}`,
						source: edge.source,
						target: edge.target,
						animated: edge.animated || false,
						label: edge.label || "",
						markerEnd: { ...edge.markerEnd },
						type: edge.type,
					});
				});


				setNodes(iNodes);
				setEdges(iEdges);
				setLoading(false);
			} catch (error) {
				console.error("Error fetching structure:", error.message);
				setLoading(false);
				if (error.message === "Unauthorized") {
					navigate("/auth/login");
				}
			}
		};

		fetchTemplateData();
	}, [template_id, navigate]);

	// const handleHeaderCheckboxChange = () => {
	//   const newCheckedStatus = !allChecked;
	//   setAllChecked(newCheckedStatus);
	//   if (newCheckedStatus) {
	//     setCheckedItems(
	//       data1.data.filter((item) => item.status).map((item) => item._id)
	//     );
	//   } else {
	//     setCheckedItems([]);
	//   }
	// };
	const handleHeaderCheckboxChange = () => {
		const newCheckedStatus = !allChecked;

		// Check if all filtered items with status are checked
		const allFilteredChecked = filteredData
			.filter((item) => item.status)
			.every((item) => checkedItems.includes(item._id));

		if (newCheckedStatus) {
			// Select all filtered data that has status
			const itemsToCheck = filteredData
				.filter((item) => item.status)
				.map((item) => item._id);

			// Merge with existing checked items to preserve selections from other pages
			setCheckedItems((prev) => {
				const newSet = new Set([...prev, ...itemsToCheck]);
				return Array.from(newSet);
			});

			setAllChecked(true);
		} else {
			// Uncheck only filtered items
			const filteredIds = filteredData.map((item) => item._id);
			setCheckedItems((prev) => prev.filter((id) => !filteredIds.includes(id)));
			setAllChecked(false);
		}
	};


	const handleHeaderCheckboxChange1 = (e) => {
		if (e.target.checked) {
			// Select all filtered items
			const filteredItemIds = filteredData.map((item) => item._id);
			setCheckedItems1([...new Set([...checkedItems1, ...filteredItemIds])]);
		} else {
			// Deselect all filtered items
			const filteredItemIds = filteredData.map((item) => item._id);
			setCheckedItems1(
				checkedItems1.filter((itemId) => !filteredItemIds.includes(itemId))
			);
		}
	};

	const handleRowCheckboxChange1 = useCallback(
		(itemId) => {
			setCheckedItems1((prevCheckedItems) => {
				const updatedCheckedItems = prevCheckedItems.includes(itemId)
					? prevCheckedItems.filter((id) => id !== itemId) // Uncheck the item
					: [...prevCheckedItems, itemId]; // Check the item
				// Update `allChecked` state based on the updated list of checked items
				// setAllChecked1(
				//   data1.data.every((item) => {
				//     return item.status ? updatedCheckedItems.includes(item._id) : true;
				//   })
				// );
				return updatedCheckedItems;
			});

		},
		[data1.data]
	);
	const handleRowCheckboxChange = useCallback(
		(itemId) => {
			setCheckedItems((prevCheckedItems) => {
				const updatedCheckedItems = prevCheckedItems.includes(itemId)
					? prevCheckedItems.filter((id) => id !== itemId) // Uncheck the item
					: [...prevCheckedItems, itemId]; // Check the item
				// Update `allChecked` state based on the updated list of checked items
				setAllChecked(
					data1.data.every((item) => {
						return item.status ? updatedCheckedItems.includes(item._id) : true;
					})
				);
				return updatedCheckedItems;
			});

		},
		[data1.data]
	);

	const submitDataToAPI = async () => {
		setLoading(true);
		const fromMasterName = selectedNode.data.label;
		const toMasterName = sourceName;

		console.log("🔄 Saving template-master data...");
		try {
			// Fetch master data and master fields once for all items to reduce API calls
			const masterResponse = await fetchMasterData(masterId);

			if (!masterResponse) {
				console.error("Failed to fetch master data. Aborting submission.");
				return;
			}

			const { data: masterData, masterFields } = masterResponse;

			// Log the masterData to see its structure


			// Find the default field
			const defaultField = masterFields.find((field) => field.default);
			if (!defaultField) {
				console.error("No default field found. Aborting submission.");
				return;
			}
			const defaultFieldName = defaultField.field_name;

			const fieldData = checkedItems.map((itemId) => {
				const connection = selectedConnections[itemId];

				const nodes = connection
					? connection.map((option) => {
						const document = masterData.find(
							(doc) => doc._id === option.value
						);
						return {
							document_id: option.value,
							[toMasterName]: option.label,
							heading: option.heading,
						};
					})
					: [];

				// Find the document related to the itemId
				const document = masterData.find((doc) => doc._id === itemId);
				const documentCode = document ? document[defaultFieldName] : null;

				if (!document) {
					console.warn(`No document found for itemId: ${itemId}`);
				}

				return {
					master_name: fromMasterName,
					document_id: itemId,
					document_code: documentCode,
					nodes,
				};
			});



			// Properly check the condition for headingName
			const headingName =
				sourceId !== "1" ? connectedNodeNames.join("-") : null;

			// The payload for the POST request
			const payload = {
				template_type_id: template_type_id,
				template_id: templateId,
				master_id: masterId,
				leaf_node: leafNode,
				heading_name: headingName,
				source_id: sourceId,
				data: fieldData,
			};



			const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-master/create`;


			const response = await fetchWrapper(
				url,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(payload),
				},
				navigate
			);


			// Show success toast notification
			toast.success("Data saved successfully");
			setLoading(false);
			// Clear selections
			setSelectedConnections({});
			setCheckedItems([]);
			setAllChecked(false);
			setIsMenuVisible(false);
			setSourceName("");
		} catch (error) {
			console.error("Error saving data:", error.message);
			toast.error(error.message);
			setLoading(false);
		}
	};

	// Function to get the nodeId of the previous node based on the current node
	const getSourceId = (edgeArray, target) => {
		// Find the object with the specified target
		const targetObject = edgeArray.find((edge) => edge.target === target);

		// If object is found, return the object and its source
		if (targetObject) {
			const sourceId = targetObject.source;
			setSourceId(sourceId);
			getSourceName(nodeArray, sourceId);

		} else {
			setSourceId("1");

		}

	};

	const getSourceName = (nodeArray, target) => {
		// Find the object with the specified target
		const targetObject = nodeArray.find((node) => node.id === target);

		// If object is found, return the object and its source
		if (targetObject) {
			const sourceName = targetObject.data.label;
			setSourceName(sourceName);

		} else {
			console.error("No source name found");
		}
	};

	const getTargetId = (edgeArray, source) => {
		// Find the object with the specified target
		const sourceObject = edgeArray.find((edge) => edge.source === source);

		// If object is found, return the object and its source
		if (sourceObject) {
			const targetId = sourceObject.target;


			getTargetName(nodeArray, targetId);

		} else {
			setLeafNode(true);

		}

	};

	const getTargetName = (nodeArray, target) => {
		// Find the object with the specified target
		const targetObject = nodeArray.find((node) => node.id === target);

		// If object is found, return the object and its source
		if (targetObject) {
			const targetName = targetObject.data.label;
			// setTargetName(targetName);

		} else {
			console.error("No target name found");
		}
	};



	useEffect(() => {
		const errorHandler = (e) => {
			if (
				e.message.includes(
					"ResizeObserver loop completed with undelivered notifications" ||
					"ResizeObserver loop limit exceeded"
				)
			) {
				const resizeObserverErr = document.getElementById(
					"webpack-dev-server-client-overlay"
				);
				if (resizeObserverErr) {
					resizeObserverErr.style.display = "none";
				}
			}
		};
		window.addEventListener("error", errorHandler);

		return () => {
			window.removeEventListener("error", errorHandler);
		};
	}, []);

	useEffect(() => {
		if (isMenuVisible) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "";
		}

		return () => {
			document.body.style.overflow = "";
		};
	}, [isMenuVisible]);

	const MultiValue = ({ index, getValue }) => {
		// Only display the count on the first item
		const values = getValue();
		if (index === 0) {
			const length = values.length;
			return (
				<div>
					{length} item{length !== 1 ? "s" : ""} selected
				</div>
			);
		}
		return null;
	};

	const Option = (props) => {
		const { innerRef, innerProps } = props;

		if (props.data.value !== "selectAll") {
			return (
				<components.Option {...props}>
					<div>
						<input
							style={{
								width: "16px",
								height: "16px",
							}}
							type="checkbox"
							checked={props.isSelected}
							onChange={() => null}
						/>{" "}
						{props.label}
					</div>
				</components.Option>
			);
		} else {
			return (
				<div
					ref={innerRef}
					{...innerProps}
					onClick={() => props.selectProps.onSelectAllClick(props.data)}
				>
					<div style={{ marginLeft: "8px", fontSize: "14px" }}>
						<input
							type="checkbox"
							checked={props.selectProps.allSelected[props.data.id] || false}
							readOnly
							style={{
								width: "16px",
								height: "16px",
								marginRight: "8px",
							}}
						/>
						Select All
					</div>
				</div>
			);
		}
	};

	const handleSelectChange = (id, selectedOptions) => {
		setSelectedConnections((prevState) => ({
			...prevState,
			[id]: selectedOptions,
		}));

		const selectedIds = selectedOptions.map((option) => option.value);
		const allIds = previousConnections.map((connection) => connection.id);
		const allSelectedState = allIds.every((id) => selectedIds.includes(id));

		// const allSelectedState = selectedOptions.length === previousConnections.length;
		setAllSelected((prevState) => ({
			...prevState,
			[id]: allSelectedState,
		}));
	};

	const handleSelectAllClick = (selectAllOption) => {
		const id = selectAllOption.id;
		const allSelectedState = allSelected[id];

		if (allSelectedState) {
			handleSelectChange(id, []);
		} else {
			const allOptions = previousConnections.map((connection) => ({
				value: connection.id,
				label: connection.template_master_code,
			}));

			handleSelectChange(id, allOptions);
		}
	};

	const handleSelectedItems = (selectedOptions) => {
		setSelectedItems(selectedOptions);
	};

	const handleSelectedAllItems = (selectAllOption) => {
		const allSelectedState = allSelectedItems[selectAllOption.id];

		if (allSelectedState) {
			setSelectedItems([]);
			setAllSelectedItems({});
		} else {
			const allOptions = previousConnections.map((connection) => ({
				value: connection.id,
				label: connection.template_master_code,
			}));
			setSelectedItems(allOptions);
			setAllSelectedItems({ [selectAllOption.id]: true });
		}
	};

	return (
		<>
			{loading ? (
				<Loader />
			) : (
				<div>
					<div className="tb-responsive templatebuilder-body">
						<div className="tb-container pt-3">
							<nav
								className="breadcrumb-nav show-breadcrumb"
								aria-label="breadcrumb"
							>
								<h5>Update {master ? TemplateTypeName : "Loading..."}</h5>
								<ol className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#">Templates</a>
									</li>
									<li className="breadcrumb-item">
										<a className="">
											{master ? TemplateTypeName : "Loading..."}
										</a>
									</li>
									<li className="breadcrumb-item">
										<a href="#">{templateName ? templateName : "Loading..."}</a>
									</li>
									<li className="breadcrumb-item active" aria-current="page">
										Update
									</li>
								</ol>
							</nav>

							<div
								className="row tb-header align-content-center"
								style={{ marginRight: 0, marginLeft: 0 }}
							>
								<div className="col-md-3" style={{ width: "300px" }}>
									<div className="tb-search-div">
										<img
											src={search1}
											className="tg-search-icon"
											alt="search icon"
										/>
										<input
											className="tb-search-input"
											placeholder="search"
											style={{ padding: "8px 35px" }}
											value={searchQuery}
											onChange={handleSearchChange}
										/>
									</div>
								</div>

								<div className="col text-center">
									<div className="d-flex justify-content-between align-content-center">
										<h6 className="align-content-center">Template Builder</h6>
										<div className="d-flex gap-3">
											<div className="tb-search-div d-flex gap-3">
												<img
													src={folder}
													className="tg-search-icon"
													alt="folder icon"
												/>
												<input
													className="tb-search-input"
													placeholder="Template Code"
													style={{ padding: "8px 35px", width: "350px" }}
													value={templateCode}
													onChange={(e) => setTemplateCode(e.target.value)}
												/>
											</div>
											<div className="tb-search-div d-flex gap-3">
												<img
													src={folder}
													className="tg-search-icon"
													alt="folder icon"
												/>
												<input
													className="tb-search-input"
													placeholder="Template Name"
													style={{ padding: "8px 35px", width: "350px" }}
													value={templateNameInput}
													onChange={(e) => setTemplateNameInput(e.target.value)}
													ref={templateNameRef}
												/>
												<button onClick={handleSave} className="tb-save-btn">
													SAVE
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div
								className="dndflow"
								style={{ position: "relative" }}
								onClick={hideButton}
							>
								<Sidebar
									master={master}
									usedNodes={usedNodes}
									searchQuery={searchQuery}
								/>

								<div
									id="overlay"
									className={`modal fade ${isMenuVisible ? "show" : ""}`}
									tabIndex="-1"
									role="dialog"
									style={{
										zIndex: 30,
										display: isMenuVisible ? "block" : "none",
										transition: "width 2s",
									}}
								>
									<div>
										<div
											className="addunit-card"
											style={{
												// position: "relative",
												width: "100%",
												height: "100%",
											}}
										>
											<div className="addunit-header">
												<h4 className="text-uppercase">
													{selectedNode && selectedNode.data.label
														? selectedNode.data.label
														: "Loading"}
												</h4>
												<button
													style={{
														border: "none",
														backgroundColor: "inherit",
													}}
													type="button"
													className="close"
													onClick={closeModal}
												>
													<img
														src={close}
														width="28px"
														height="28px"
														alt="Close"
													/>
												</button>
											</div>
											{previousConnections.length > 0 && (
												<>
													<div className="container containerdiv1 mt-3">
														<div className="row ">
															{/* dropdown1 */}
															<div
																className="col-5"
																style={{ lineHeight: "0.5" }}
															>
																<label
																	htmlFor="name"
																	className="addunit-form-text"
																	style={{ marginLeft: "3px" }}
																>
																	Select
																</label>
																<div
																	className="dropdown"
																	style={{ width: "100%" }}
																>
																	<input
																		style={{
																			height: "48px",
																			marginTop: "-4px",
																		}}
																		type="text"
																		className="form-control input_dropdown"
																		onClick={toggleDropdown}
																		placeholder={`${checkedItems1.length} Item Selected           `}
																	/>
																	<br />
																	<br />
																	{isOpen && (
																		<div
																			ref={dropdownRef}
																			className="dropdown-content mt-3"
																			style={{
																				padding: "10px",
																				marginLeft: "100px",
																				width: "100%",
																				maxHeight: "400px",
																				overflowY: "auto",
																				borderRadius: "4px",
																				position: "absolute",
																				backgroundColor: "white",
																				zIndex: 1000,
																			}}
																		>
																			<input
																				className="form-control dropdown1_input"
																				type="text"
																				placeholder="Search..."
																				value={searchQuery}
																				onChange={handleSearchChange}
																				ref={searchInputRef}
																			/>
																			{filteredData.length === 0 ? (
																				<div
																					style={{
																						padding: "20px",
																						textAlign: "center",
																						color: "gray",
																					}}
																				>
																					No records found
																				</div>
																			) : (
																				<table className="table bg-white align-middle table-text mt-2">
																					<thead className="table-head align-middle">
																						<tr>
																							<th className="table-check">
																								<input
																									type="checkbox"
																									checked={
																										checkedItems1.length >= 1 &&
																										checkedItems1.length ===
																										filteredData.length
																									}
																									onChange={
																										handleHeaderCheckboxChange1
																									}
																								/>
																							</th>
																							<th className="col">ID</th>
																							{data1.master &&
																								data1.master.masterFields &&
																								data1.master.masterFields.map(
																									(field, index) => (
																										<th
																											className="col text-uppercase"
																											key={index}
																										>
																											<span>
																												{field.display_name}
																											</span>
																										</th>
																									)
																								)}
																						</tr>
																					</thead>
																					<tbody>
																						{filteredData.map((item, index) => (
																							<tr
																								key={item._id}
																								className={
																									item.status
																										? ""
																										: "disabled text-muted"
																								}
																								onClick={() =>
																									handleRowCheckboxChange1(
																										item._id
																									)
																								}
																							>
																								<td
																									className="table-check"
																									onClick={(e) =>
																										e.stopPropagation()
																									}
																								>
																									<input
																										type="checkbox"
																										checked={checkedItems1.includes(
																											item._id
																										)}
																										onChange={() =>
																											handleRowCheckboxChange1(
																												item._id
																											)
																										}
																										disabled={!item.status}
																									/>
																								</td>
																								<td className="col">
																									{index + 1}
																								</td>
																								{data1.master &&
																									data1.master.masterFields &&
																									data1.master.masterFields.map(
																										(field, cellIndex) => (
																											<td key={cellIndex}>
																												{item[
																													field.field_name
																												] || ""}
																											</td>
																										)
																									)}
																							</tr>
																						))}
																					</tbody>
																				</table>
																			)}
																		</div>
																	)}
																</div>
															</div>
															{/* dropdown2 */}
															<div
																className="col-5 "
																style={{ lineHeight: "0.5" }}
															>
																{previousConnections.length > 0 && (
																	<label
																		htmlFor="name"
																		className="addunit-form-text "
																		style={{ marginLeft: "3px" }}
																	>
																		Select {sourceName}
																	</label>
																)}
																<div
																	className="dropdown-container"
																	style={{ marginTop: "-4px" }}
																>
																	<div className="custom-select-container">
																		<Select
																			components={{ MultiValue, Option }}
																			value={selectedItems || ""}
																			onChange={handleSelectedItems}
																			options={[
																				{
																					value: "selectAll",
																					label: "Select All",
																				},
																				...previousConnections.map(
																					(connection) => ({
																						value: connection.id,
																						label:
																							connection.template_master_code,
																					})
																				),
																			]}
																			isMulti
																			closeMenuOnSelect={false}
																			hideSelectedOptions={false}
																			placeholder="Select connection(s)"
																			getOptionLabel={(option) => option.label}
																			getOptionValue={(option) => option.value}
																			styles={{
																				control: (provided, state) => ({
																					...provided,
																					backgroundColor: "white",
																					borderColor: state.isFocused
																						? "#007BFF"
																						: "#CED4DA",
																					boxShadow: state.isFocused
																						? "0 0 0 0.2rem rgba(0,123,255,.25)"
																						: null,
																					"&:hover": {
																						borderColor: "#007BFF",
																					},
																				}),
																				option: (provided, state) => ({
																					...provided,
																					padding: "4px 8px",
																					fontSize: "15px",
																					height: "25px",
																					marginTop: "8px",
																					backgroundColor: state.isSelected
																						? "#ffffff"
																						: state.isFocused
																							? "#E9ECEF"
																							: null,
																					color: state.isSelected
																						? "black"
																						: "black",
																					"&:hover": {
																						backgroundColor: "#E9ECEF",
																					},
																				}),
																				menu: (provided) => ({
																					...provided,
																					zIndex: 9999,
																				}),
																				multiValue: (provided) => ({
																					...provided,
																					display: "none",
																				}),
																			}}
																			onSelectAllClick={handleSelectedAllItems}
																			allSelected={allSelectedItems}
																		/>
																	</div>
																</div>
															</div>
															{/* button */}
															<div
																className="col-2 "
																style={{ marginTop: "1.4rem" }}
															>
																{/* <button className="update-btn" onClick={ADDFun}>
									<span className="plus-icon">
									  <img src={plus1} alt="Plus Icon" />
									</span>
									Add
								  </button> */}
																<button className="update-btn" onClick={ADDFun}>
																	<span className="plus-icon">
																		<img src={plus1} alt="Plus Icon" />
																	</span>
																	Add
																</button>
															</div>
														</div>
													</div>
												</>
											)}

											{/* ///////Main table//////////// */}
											<div className="table-container">
												{/* Search + pagination header */}
												{renderSearchAndPagination(previousConnections.length === 0)}

												<div className="table-responsive scrollable-table">
													<table className="table bg-white align-middle table-text">
														<thead className="table-head align-middle">
															<tr>
																<th className="table-check">
																	<input
																		type="checkbox"
																		checked={allChecked}
																		onChange={handleHeaderCheckboxChange}
																	/>
																</th>
																<th className="col">ID</th>
																{data1.master?.masterFields?.map((field, index) => (
																	<th className="col text-uppercase" key={index}>
																		<span>{field.display_name}</span>
																	</th>
																))}
																{previousConnections.length > 0 && (
																	<th className="text-uppercase">SELECT {sourceName}</th>
																)}
															</tr>
														</thead>
														<tbody>
															{paginatedData.map((item, index) => {
																const globalIndex = (currentPage - 1) * itemsPerPage + index;
																return (
																	<tr
																		key={item._id}
																		className={item.status ? "" : "disabled text-muted"}
																	>
																		<td className="table-check">
																			<input
																				type="checkbox"
																				checked={checkedItems.includes(item._id)}
																				onChange={() => handleRowCheckboxChange(item._id)}
																				disabled={!item.status}
																			/>
																		</td>
																		<td className="col">{globalIndex + 1}</td>
																		{/* {data1.master?.masterFields?.map((field, cellIndex) => (
																		<td key={cellIndex}>{item[field.field_name] || ""}</td>
																	))} */}
																		{/* // Inside the tbody mapping (for both tables) */}
																		{data1.master?.masterFields?.map((field, cellIndex) => {
																			const value = item[field.field_name];
																			let displayValue;
																			if (value === null || value === undefined) {
																				displayValue = '';
																			} else if (typeof value === 'object') {
																				// Safely stringify objects to avoid rendering errors
																				displayValue = JSON.stringify(value, null, 2); // Pretty-print for readability, or just JSON.stringify(value)
																				// Alternatively, if you expect specific object structures, access properties like value.someKey
																			} else {
																				displayValue = value.toString(); // Ensure primitives are strings
																			}
																			return <td key={cellIndex}>{displayValue}</td>;
																		})}
																		{previousConnections.length > 0 && (
																			<td className="custom-select-container">
																				<Select
																					components={{ MultiValue, Option }}
																					value={selectedConnections[item._id] || ""}
																					onChange={(selectedOption) =>
																						handleSelectChange(item._id, selectedOption)
																					}
																					options={[
																						{ value: "selectAll", label: "Select All", id: item._id },
																						...previousConnections.map((connection) => ({
																							value: connection.id,
																							label: connection.template_master_code,
																						})),
																					]}
																					isMulti
																					closeMenuOnSelect={false}
																					hideSelectedOptions={false}
																					placeholder="Select connection(s)"
																					getOptionLabel={(option) => option.label}
																					getOptionValue={(option) => option.value}
																					styles={{
																						control: (provided, state) => ({
																							...provided,
																							backgroundColor: "white",
																							borderColor: state.isFocused ? "#007BFF" : "#CED4DA",
																							boxShadow: state.isFocused
																								? "0 0 0 0.2rem rgba(0,123,255,.25)"
																								: null,
																							"&:hover": { borderColor: "#007BFF" },
																						}),
																						option: (provided, state) => ({
																							...provided,
																							padding: "4px 8px",
																							fontSize: "12px",
																							height: "30px",
																							backgroundColor: state.isSelected
																								? "#ffffff"
																								: state.isFocused
																									? "#E9ECEF"
																									: null,
																							color: state.isSelected ? "black" : "black",
																							"&:hover": { backgroundColor: "#E9ECEF" },
																						}),
																						menu: (provided) => ({ ...provided, zIndex: 9999 }),
																						multiValue: (provided) => ({ ...provided, display: "none" }),
																					}}
																					onSelectAllClick={handleSelectAllClick}
																					allSelected={allSelected}
																				/>
																			</td>
																		)}
																	</tr>
																);
															})}
														</tbody>
													</table>
												</div>
												{/* Pagination Controls */}
												<div className="mt-3 py-2 border-top">
													{renderPaginationControls()}
												</div>
											</div>

											{/* <div className="table-container">
						  <div className="table-responsive scrollable-table ">
							<table className="table bg-white align-middle table-text">
							  <thead className="table-head align-middle">
								<tr>
								  <th className="table-check">
									<input
									  type="checkbox"
									  checked={allChecked}
									  onChange={handleHeaderCheckboxChange}
									/>
								  </th>
								  <th className="col">ID</th>
								  {data1.master &&
									data1.master.masterFields &&
									data1.master.masterFields.map(
									  (field, index) => (
										<th
										  className="col text-uppercase"
										  key={index}
										>
										  <span>{field.display_name}</span>
										</th>
									  )
									)}
								  {previousConnections.length > 0 && (
									<th className="text-uppercase">
									  SELECT {sourceName}
									</th>
								  )}
								</tr>
							  </thead>
							  <tbody>
								{data1.data &&
								  data1.data.map((item, index) => (
									<tr
									  key={item._id}
									  className={
										item.status ? "" : "disabled text-muted"
									  }
									>
									  <td className="table-check">
										<input
										  type="checkbox"
										  checked={checkedItems.includes(
											item._id
										  )}
										  onChange={() =>
											handleRowCheckboxChange(item._id)
										  }
										  disabled={!item.status}
										/>
									  </td>
									  <td className="col">{index + 1}</td>
									  {data1.master &&
										data1.master.masterFields &&
										data1.master.masterFields.map(
										  (field, cellIndex) => (
											<td key={cellIndex}>
											  {item[field.field_name] || ""}
											</td>
										  )
										)}
									  {previousConnections.length > 0 && (
										<td className="custom-select-container">
										  <Select
											components={{ MultiValue, Option }}
											value={
											  selectedConnections[item._id] || ""
											}
											onChange={(selectedOption) =>
											  handleSelectChange(
												item._id,
												selectedOption
											  )
											}
											options={[
											  {
												value: "selectAll",
												label: "Select All",
												id: item._id,
											  },
											  ...previousConnections.map(
												(connection) => ({
												  value: connection.id,
												  label:
													connection.template_master_code,
												})
											  ),
											]}
											isMulti
											closeMenuOnSelect={false}
											hideSelectedOptions={false}
											placeholder="Select connection(s)"
											getOptionLabel={(option) =>
											  option.label
											}
											getOptionValue={(option) =>
											  option.value
											}
											styles={{
											  control: (provided, state) => ({
												...provided,
												backgroundColor: "white",
												borderColor: state.isFocused
												  ? "#007BFF"
												  : "#CED4DA",
												boxShadow: state.isFocused
												  ? "0 0 0 0.2rem rgba(0,123,255,.25)"
												  : null,
												"&:hover": {
												  borderColor: "#007BFF",
												},
											  }),
											  option: (provided, state) => ({
												...provided,
												padding: "4px 8px",
												fontSize: "12px",
												height: "30px",
												backgroundColor: state.isSelected
												  ? "#ffffff"
												  : state.isFocused
													? "#E9ECEF"
													: null,
												color: state.isSelected
												  ? "black"
												  : "black",
												"&:hover": {
												  backgroundColor: "#E9ECEF",
												},
											  }),
											  menu: (provided) => ({
												...provided,
												zIndex: 9999,
											  }),
											  multiValue: (provided) => ({
												...provided,
												display: "none",
											  }),
											}}
											onSelectAllClick={
											  handleSelectAllClick
											}
											allSelected={allSelected}
										  />
										</td>
									  )}
									</tr>
								  ))}
							  </tbody>
							</table>
						  </div>
						</div> */}

											<div
												className="addunit-card-footer"
												style={{ position: "absolute", bottom: 0 }}
											>
												<button
													type="button"
													className="discard-btn"
													onClick={closeModal}
												>
													Close
												</button>
												<button
													onClick={submitDataToAPI}
													className="update-btn"
												>
													{" "}
													Save Changes{" "}
												</button>
											</div>
										</div>
									</div>
								</div>

								<ReactFlowProvider>
									<div
										className="reactflow-wrapper"
										ref={reactFlowWrapper}
										style={{ height: 600 }}
									>
										<ReactFlow
											nodes={nodes}
											edges={edges}
											nodeTypes={nodeTypes}
											edgeTypes={edgeTypes}
											onNodesChange={onNodesChange}
											onEdgesChange={onEdgesChange}
											onConnect={onConnect}
											onInit={setReactFlowInstance}
											onDrop={onDrop}
											onDragOver={onDragOver}
											onNodeDoubleClick={onNodeDoubleClick}
											onNodeContextMenu={onNodeContextMenu}
											onEdgeClick={onEdgeClick}
											onLoad={(reactFlowInstance) =>
												reactFlowInstance.fitView()
											}
											fitView
										>
											<Controls />
											<SmoothStepEdge type="smoothstep" />
											{edgeToDelete && (
												<div
													className="edit-cont"
													style={{
														cursor: "pointer",
														position: "absolute",
														left: edgeToDelete.position.x,
														top: edgeToDelete.position.y,
														zIndex: 10,
													}}
												>
													<button
														className="edit-btn"
														onClick={() => openEdgeLabelModal(edgeToDelete.id)}
													>
														Add Label
													</button>
													<button
														className="delete-btn"
														onClick={(e) => {
															e.stopPropagation();
															onDeleteEdge();
														}}
													>
														Delete Edge
													</button>
												</div>
											)}
											<Background
												id="1"
												gap={10}
												color="#e8e8e8"
												variant={BackgroundVariant.Lines}
											/>
										</ReactFlow>
									</div>
								</ReactFlowProvider>

								{contextMenu.isOpen && (
									<div
										className="edit-cont"
										style={{
											position: "absolute",
											top: contextMenu.position.y,
											left: contextMenu.position.x,
										}}
										onClick={closeContextMenu}
									>
										{/**
					   *
					   * <button
						className="edit-btn"
						onClick={() => setIsMenuVisible(true)}
					  >
						Edit
					  </button>
					   */}
										<button
											className="delete-btn"
											onClick={() => onDeleteNode(selectedNode)}
										>
											Delete
										</button>
									</div>
								)}

								<div
									id="overlay"
									className={`modal fade ${edgeLabelModal.isOpen ? "show" : ""
										}`}
									tabIndex="-1"
									role="dialog"
									style={{
										zIndex: 30,
										display: edgeLabelModal.isOpen ? "block" : "none",
										transition: "width 2s",
									}}
								>
									<div>
										<div className="addunit-card Width 25%">
											<div className="addunit-header">
												<h4>Add or Edit Edge Label</h4>
												<button
													style={{ border: "none", backgroundColor: "inherit" }}
													type="button"
													className="close"
													onClick={() =>
														setEdgeLabelModal({
															isOpen: false,
															label: "",
															edgeId: null,
														})
													}
												>
													<img
														src={close}
														width="28px"
														height="28px"
														alt="Close"
													/>
												</button>
											</div>

											<div className="addunit-form">
												<div className="row">
													<div className="d-flex flex-column">
														<label
															htmlFor="edge-name"
															className="addunit-form-text"
														>
															Edge Label
														</label>
														<input
															type="text"
															className="form-control"
															id="edge-name"
															value={edgeLabelModal.label}
															onChange={(e) =>
																setEdgeLabelModal({
																	...edgeLabelModal,
																	label: e.target.value,
																})
															}
														/>
													</div>
												</div>
											</div>

											<div className="addunit-card-footer">
												<button
													type="button"
													className="discard-btn"
													onClick={() =>
														setEdgeLabelModal({
															isOpen: false,
															label: "",
															edgeId: null,
														})
													}
												>
													Close
												</button>
												<button
													type="button"
													className="update-btn"
													onClick={() =>
														addLabelToEdge(
															edgeLabelModal.edgeId,
															edgeLabelModal.label
														)
													}
												>
													Add Label
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<ToastContainer autoClose={4000} position={"top-right"} />
		</>
	);
};

export default DnDFlow;
